// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"234":"70851bf8","405":"be0810f5"}[chunkId] + ".css";
};